<mat-expansion-panel class="u-expansion-panel" [expanded]="expanded()" hideToggle>
  <mat-expansion-panel-header>
    <div class="header-content">
      <ng-content select="[panel-header]"></ng-content>
      <u-icon
        [model]="{ type: 'font', value: 'icon-chevron-right' }"
        [styles]="{ fontSize: '6px', lineHeight: '6px', fontWeight: 'bold' }"
      ></u-icon>
    </div>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
